import type { RiskProfileQueryParams } from '../../../hooks/useRiskProfileQueryParams'
import type { RiskProfileMetricOption } from '../../../types/riskProfile.types'
import { RiskByElementWidget } from '../widgets/RiskByElementWidget'
import { RiskByHazardWidget } from '../widgets/RiskByHazardWidget'
import { RiskProfileAssetRiskQuadrantWidget } from '../widgets/RiskProfileAssetRiskQuadrantWidget'
import { RiskProfileLossCurveWidget } from '../widgets/RiskProfileLossCurveWidget'

interface TypeChartsSectionProps {
  queryParams: RiskProfileQueryParams | null
  metricOption: RiskProfileMetricOption
  showSingleElementCharts: boolean
}

export function TypeChartsSection({
  queryParams,
  metricOption,
  showSingleElementCharts,
}: TypeChartsSectionProps) {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <RiskByElementWidget queryParams={queryParams} metricOption={metricOption} />
      <RiskByHazardWidget queryParams={queryParams} metricOption={metricOption} />
      {showSingleElementCharts && (
        <>
          {(metricOption.metric === 'damage_cost' ||
            metricOption.metric === 'replacement_cost' ||
            metricOption.metric === 'quantity') && (
            <RiskProfileLossCurveWidget queryParams={queryParams} metricOption={metricOption} />
          )}
          {(metricOption.metric === 'damage_cost' ||
            metricOption.metric === 'replacement_cost') && (
            <RiskProfileAssetRiskQuadrantWidget queryParams={queryParams} />
          )}
        </>
      )}
    </div>
  )
}
